export default "__VITE_ASSET__yGw5YXne__"